// Pure helpers for the V3 circle views (M14–M16, M69–M76, M120); no network, no storage.
import { own, text, lookup } from "./memberDerive";
import { membershipState, isGroupPaused } from "./groupMembership";

// Core 1.1 join_policy: "offen" | "bestaetigung" (stored text unchanged); anything else claims nothing.
const POLICY = { offen: "open", bestaetigung: "approval" };
export const joinPolicy = (g) => lookup(POLICY, own(g, "join_policy")) || null;
const POLICY_TEXT = { open: "Offener Beitritt", approval: "Beitritt auf Anfrage" };
export const policyText = (g) => POLICY_TEXT[joinPolicy(g)] || "Beitrittsregel nicht angegeben";

const STATE_TEXT = { member: "Mitglied", join_pending: "Aufnahme ausstehend", join_declined: "Anfrage abgelehnt", not_member: "Nicht Mitglied", unknown: "Status unbekannt" };
export const stateText = (g) => STATE_TEXT[membershipState(g)];

export const groupName = (g) => text(own(g, "name")).trim() || "Kreis";
export const groupHref = (g, rest = "") => `/kreise/${encodeURIComponent(g.id)}${rest}`;

// M14 context column: join rule, own membership and a known pause – no city, the Core has none (D-50).
export const groupContext = (g) => [policyText(g), stateText(g), isGroupPaused(g) && "pausiert, nur lesen"].filter(Boolean).join(" · ");

export function findGroup(list, id) {
  if (!Array.isArray(list)) return null;
  return list.find((g) => g && typeof g === "object" && (typeof g.id === "string" || typeof g.id === "number") && String(g.id) === String(id)) || null;
}

// Members-only content (M15 room, M72, M73, M76) needs a confirmed membership from the Core; nothing else unlocks it.
export const canSeeInternal = (g) => membershipState(g) === "member";

// Which overview /kreise/:id shows: room (M15), pending (M71) or preview (M69); a missing circle is M120.
export function groupView(g) {
  if (!g) return "no_access";
  const s = membershipState(g);
  return s === "member" ? "room" : s === "join_pending" ? "pending" : "preview";
}

export function membersCountText(g) {
  const n = own(g, "members_count");
  return Number.isSafeInteger(n) && n >= 0 ? `${n} ${n === 1 ? "bestätigtes Mitglied" : "bestätigte Mitglieder"}` : "Anzahl nicht angegeben";
}

// Old deep links /kreise/:id?reiter=… lead to the V3 sub-views.
const LEGACY = { regeln: "regeln", mitglieder: "mitglieder", treffen: "treffen" };
export const legacyTab = (search) => lookup(LEGACY, new URLSearchParams(typeof search === "string" ? search : "").get("reiter") || "") || "";

// M16 draft: checked only in the form – submitting has no Core endpoint (D-57).
export const emptyProposal = () => ({ name: "", description: "", policy: "bestaetigung", rules: "" });
const len = (v) => Array.from(String(v ?? "").trim()).length;
export const proposalRules = (raw) => String(raw ?? "").split("\n").map((r) => r.trim()).filter(Boolean);
export function proposalErrors(d) {
  const e = {};
  if (!len(d.name)) e.name = "Bitte gib einen Namen für den Kreis ein.";
  else if (len(d.name) > 80) e.name = "Der Name darf höchstens 80 Zeichen lang sein.";
  if (!len(d.description)) e.description = "Bitte beschreibe kurz, worum es im Kreis geht.";
  else if (len(d.description) > 500) e.description = "Die Beschreibung darf höchstens 500 Zeichen lang sein.";
  if (!Object.prototype.hasOwnProperty.call(POLICY, d.policy)) e.policy = "Bitte wähle, wie der Beitritt funktioniert.";
  const rules = proposalRules(d.rules);
  if (!rules.length) e.rules = "Bitte nenne mindestens eine Regel.";
  else if (rules.length > 10) e.rules = "Bitte höchstens 10 Regeln, eine pro Zeile.";
  else if (rules.some((r) => Array.from(r).length > 200)) e.rules = "Jede Regel darf höchstens 200 Zeichen lang sein.";
  return e;
}
